import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ContactPhone from 'components/ContactPhone'
import classNames from 'classnames'
import styles from './styles.scss'

export default class ErrorScreen extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    phoneNumber: PropTypes.string,
    children: PropTypes.any,
    linkTarget: PropTypes.string,
    linkText: PropTypes.string,
    textClass: PropTypes.string,
  }

  static defaultProps = {
    text: '<h2>Something went wrong...</h2><p>Unfortunately, something didn\'t go as planned. ' +
    'Please try again later or call us on the number below ' +
    'to find out if we can service your address.</p>',
    phoneNumber: undefined,
    children: null,
    linkTarget: '.',
    linkText: 'Try Again',
    textClass: undefined,
  }

  render() {
    const { text, phoneNumber, children } = this.props
    const { linkTarget, linkText, textClass } = this.props
    return (
      <div className={styles.wrapper}>
        <div
          className={classNames(textClass, styles.content)}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: text }}
        />
        {phoneNumber && <ContactPhone phoneNumber={phoneNumber} />}
        {children}
        <a className={styles.actionLink} href={linkTarget}>{linkText}</a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/ErrorScreen/index.jsx